import React from "react";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import SyncIcon from "@mui/icons-material/Sync";
import { ExtratableRepoIcon } from "assets/material-custom-icons";
import { Menu as MenuPopup } from "components/popups";
import { useUserRoleSelector } from "store";

import { RoleName } from "../../../constants";

interface Props {
  isLoading: boolean;
  setFiles: (op: string) => Promise<void>;
  onOpenDataExtractor?: () => void;
  enableSync?: boolean;
  isConnectionValid?: boolean;
  allFilesSynced?: boolean;
  hasSelectedFiles?: boolean;
  hasActiveConnection?: boolean;
  hasAtLeastOneSynced?: boolean;
}

export const Menu: React.FC<Props> = ({
  isLoading,
  setFiles,
  onOpenDataExtractor,
  enableSync = false,
  allFilesSynced = false,
  hasSelectedFiles = false,
  hasActiveConnection = false,
  hasAtLeastOneSynced = false
}) => {
  const userRole = useUserRoleSelector();

  const titlePrefix = allFilesSynced ? "" : "Download and ";

  // Sync to Altius should be enabled only if:
  // - At least one file is selected
  // - At least one file is not synced (enableSync)
  // - At least one selected file has an active connection
  const isSyncDisabled = !hasSelectedFiles || isLoading || !enableSync || !hasActiveConnection;

  // PDF Extractor should be enabled if at least one selected file is synced
  const isPdfExtractorDisabled = !hasSelectedFiles || isLoading || !hasAtLeastOneSynced;

  // All other extract options should be enabled if:
  // - At least one file is selected
  // - At least one file is synced OR dataroom is active
  const isExtractDisabled = !hasSelectedFiles || isLoading || (!hasAtLeastOneSynced && !hasActiveConnection);

  return (
    <MenuPopup
      iconButtonProps={{ sx: iconBtnsStyles, size: "sm" }}
      icon={<MoreVertIcon fontSize="md" />}
      options={[
        {
          title: "Sync to Altius",
          disabled: isSyncDisabled,
          hidden: userRole?.name !== RoleName.Admin,
          icon: <SyncIcon sx={{ fontSize: "20px" }} />,
          onClick: () => setFiles("sync")
        },
        {
          title: "Data Extractor",
          disabled: isPdfExtractorDisabled,
          icon: <ExtratableRepoIcon sx={{ width: 20, height: 16, fill: "#0a3142" }} />,
          onClick: onOpenDataExtractor
        },
        {
          title: `${titlePrefix}Extract K1`,
          disabled: isExtractDisabled,
          icon: <NoteAddOutlinedIcon sx={{ fontSize: "20px" }} />,
          onClick: () => setFiles("K1-textract")
        },
        {
          title: `${titlePrefix}Extract Management Fees`,
          disabled: isExtractDisabled,
          hidden: userRole?.name !== RoleName.Admin,
          icon: <NoteAddOutlinedIcon sx={{ fontSize: "20px" }} />,
          onClick: () => setFiles("management-fees-textract")
        },
        {
          title: `${titlePrefix}Extract by AI`,
          disabled: isExtractDisabled,
          hidden: userRole?.name !== RoleName.Admin,
          icon: <NoteAddOutlinedIcon sx={{ fontSize: "20px" }} />,
          onClick: () => setFiles("ask-ai")
        },
        // {
        //   title: "Data Extraction",
        //   disabled: isExtractDisabled,
        //   icon: <AutoAwesomeOutlinedIcon sx={{ fontSize: "20px" }} />,
        //   onClick: async () => {
        //     await openPrompt({
        //       componentType: "modal",
        //       Component: DataExtractionModal,
        //       props: { fileId: 1, fileRow: { id: 1, file_url: null, name: "" } }
        //     });
        //   }
        // },
        // {
        //   title: "Download and Extract files",
        //   disabled: isLoading,
        //   hidden: userRole?.name !== RoleName.Admin,
        //   icon: <NoteAddOutlinedIcon sx={{ fontSize: "20px" }} />,
        //   onClick: () => setFiles("file-data")
        // },
        {
          title: `${titlePrefix}Classification files`,
          disabled: isExtractDisabled,
          hidden: userRole?.name !== RoleName.Admin,
          icon: <NoteAddOutlinedIcon sx={{ fontSize: "20px" }} />,
          onClick: () => setFiles("classification-files")
        }
      ]}
    />
  );
};

const iconBtnsStyles = {
  color: "#0a3142",
  background: "white",
  border: "0.5px solid #bac7ce"
};
